<!--  -->
<template>
  <div class="pdfCom">
    <canvas :id="'canvas' + item" v-for="item in pdfHTML" :key="item" />
  </div>
</template>

<script>
const PDFJS = require('pdfjs-dist');
PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.min');
// import PDFJS from "pdfjs-dist";
// import workerSrc from 'pdfjs-dist/build/pdf.worker.entry'
// pdfJS.workerSrc = workerSrc;

export default {
  components: {},
  data() {
    return {
      pdfDoc: null, // pdfjs 生成的对象
      pdfHTML: 0, // pdfjs 生成的对象
    };
  },
  props: {
    pdfUrl: {
      type: String,
      default: '',
    },
  },
  computed: {},
  watch: {
    pdfUrl: {
      handler() {
        this.pdfHTML = '';
        if (!this.pdfUrl) return;
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true,
        });
        this.pdfComInit();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    pdfComInit() {
      const CMAP_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/';
      let obj = {};
      obj.url = this.pdfUrl;
      obj.cMapUrl = CMAP_URL;
      obj.cMapPacked = true;
      this.init(obj);
    },
    async init(fileUrl) {
      try {
        const fileContent = await PDFJS.getDocument(fileUrl).promise;
        console.log(fileContent, '成功1');
        this.getPDfFile(fileContent);
      } catch (error) {
        console.log(error, '失败');
        const pdfData = await fetch(new URL(fileUrl.url, window.location).href);
        const arrayBufferPdf = await pdfData.arrayBuffer(); // 转成 ArrayBuffer 塞给 pdf.js
        const fileContent = await PDFJS.getDocument({ data: arrayBufferPdf }).promise;
        this.getPDfFile(fileContent);
      }
    },
    getPDfFile(fileContent) {
      this.pdfDoc = fileContent;
      this.pdfHTML = fileContent.numPages;
      this.$toast.clear();
      setTimeout(() => {
        this.renderPage(fileContent.numPages);
      }, 100);
    },
    renderPage(nums) {
      for (let item = 1; item <= nums; item++) {
        // 获取页面canvas节点
        let canvas = document.getElementById(`canvas${item}`);
        // 获取上下文
        const ctx = canvas.getContext('2d');
        // 获取每一页的内容
        this.pdfDoc.getPage(item).then((page) => {
          // 文件页面的视图 1倍
          const viewport = page.getViewport(2);
          // 将画布宽度设置为视图宽度
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: ctx,
            viewport: viewport,
          };
          console.log(renderContext);
          // 渲染页面内容：参数是canvas画布上下文，以及文件视图
          page.render(renderContext);
        });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.pdfCom {
  box-sizing: border-box;
  width: 100%;
  // overflow-y: scroll;
  // padding: 36px 36px 180px;
  // height: 60vh;
  //height: calc(100vh - 145px);
  // background: #F7F8FC;
  canvas {
    width: 100% !important;
  }
}
</style>
